import type { RxJsonSchema } from 'rxdb';
import type { PlannedDeficiencyFiles } from './plannedDeficiencyFiles.types';

export const plannedDeficiencyFilesSchema: RxJsonSchema<PlannedDeficiencyFiles> = {
  type: 'object',
  version: 0,
  description: 'describes deficiency files',
  primaryKey: 'fileAimsUUID',
  properties: {
    assetPCSId: { type: 'string' },
    assetId: { type: ['number', 'null'] },
    fileId: { type: 'string' },
    fileName: { type: ['string', 'null'] },
    fileAimsUUID: { type: 'string', maxLength: 36 },
    deficiencyUUID: { type: ['string', 'null'] },
    originalFileName: { type: ['string', 'null'] },
    path: { type: ['string', 'null'] },
    legacyId: { type: ['number', 'null'] },
    isImageFile: { type: ['boolean', 'null'] },
    inspectionId: { type: ['string', 'null'] },
    deficiencyId: { type: ['string', 'null'] },
    showOnReport: { type: ['boolean', 'null'] },
    fileDescription: { type: ['string', 'null'] },
    drawingType: { type: ['number', 'null'] },
    fileCategory: { type: ['number', 'null'] },
    pcsId: { type: ['string', 'null'] },
    fkAimsfileTblSp: { type: ['string', 'null'] },
    sizeMb: { type: ['number', 'null'] },
    allowSpaccess: { type: ['boolean', 'null'] },
    siteId: { type: ['number', 'null'] },
    disciplineId: { type: ['number', 'null'] },
    userCreated: { type: ['string', 'null'] },
    userModified: { type: ['string', 'null'] },
    extension: { type: ['string', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    isDelete: { type: ['string', 'null'] },
    fileSortOrder: { type: ['number', 'null'] },
    assetInspectionTask: { type: ['number', 'null'] },
    fkInspectorField: { type: ['number', 'null'] },
    fkInspectorLead: { type: ['number', 'null'] },
  },
};
